import type { VerifyWalkerStripeTokenResponse } from "wagAPI";
import type { VerifyWalkerStripeTokenParsedResponse } from "webApp";
export const verifyWalkerStripeTokenResponseParser = ({
  message
}: VerifyWalkerStripeTokenResponse): VerifyWalkerStripeTokenParsedResponse => ({
  message
});
export default verifyWalkerStripeTokenResponseParser;